import { createFileRoute } from '@tanstack/react-router';
import AnalysisPortal from '../../components/portals/AnalysisPortal';

export const Route = createFileRoute('/analysis/_layout')({
  component: AnalysisPortal,
});
